export enum ETickerKind {
    UNAVAILABLE = -1,
    ALL = 0,
    CEX = 1,
    DEX = 2,
  }